import { CurrencyAmount, ETHER, JSBI } from '@uniswap/sdk'
import { MIN_NATIVE_CURRENCY } from '../constants'

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount): CurrencyAmount | undefined {
  if (!currencyAmount) return
  if (currencyAmount.currency === ETHER) {
    if (JSBI.greaterThan(currencyAmount.raw, MIN_NATIVE_CURRENCY)) {
      return CurrencyAmount.ether(JSBI.subtract(currencyAmount.raw, MIN_NATIVE_CURRENCY))
    } else {
      return CurrencyAmount.ether(JSBI.BigInt(0))
    }
  }
  return currencyAmount
}
